import { Check, FileCode2, FileText, FileType2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { TemplateMethod } from '../types'

const METHODS: {
  id: TemplateMethod
  icon: typeof FileCode2
  titleKey: string
  descKey: string
  iconClass: string
}[] = [
  {
    id: 'sistem',
    icon: FileCode2,
    titleKey: 'hr.belgeler.method.sistem',
    descKey: 'hr.belgeler.method.sistemDesc',
    iconClass: 'border-primary/15 bg-primary/10 text-primary',
  },
  {
    id: 'docx',
    icon: FileType2,
    titleKey: 'hr.belgeler.method.docx',
    descKey: 'hr.belgeler.method.docxDesc',
    iconClass: 'border-primary/15 bg-primary/10 text-primary',
  },
  {
    id: 'pdf',
    icon: FileText,
    titleKey: 'hr.belgeler.method.pdf',
    descKey: 'hr.belgeler.method.pdfDesc',
    iconClass: 'border-brand-orange/20 bg-brand-orange/12 text-brand-orange',
  },
]

export function MethodCards({ value, onChange }: { value: TemplateMethod; onChange: (m: TemplateMethod) => void }) {
  const { t } = useTranslation()
  return (
    <div className="grid gap-3 md:grid-cols-3">
      {METHODS.map((m) => {
        const selected = value === m.id
        const Icon = m.icon
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            className={cn(
              'relative flex items-start gap-3 rounded-2xl border bg-card p-4 text-left shadow-xs transition-colors',
              selected ? 'border-primary/40 bg-primary/[0.04] ring-1 ring-primary/20 dark:bg-primary/10' : 'hover:border-primary/30 hover:bg-primary/[0.02]',
            )}
            aria-pressed={selected}
          >
            <span className={cn('flex size-8 shrink-0 items-center justify-center rounded-lg border sm:size-10 sm:rounded-xl', m.iconClass)}>
              <Icon className="size-4 sm:size-5" />
            </span>
            <span className="min-w-0 flex-1 pr-6">
              <span className="block text-sm font-semibold">{t(m.titleKey)}</span>
              <span className="mt-0.5 line-clamp-2 block text-xs leading-snug text-muted-foreground">{t(m.descKey)}</span>
            </span>
            <span
              aria-hidden
              className={cn(
                'absolute right-3 top-3 flex size-5 items-center justify-center rounded-full border',
                selected ? 'border-primary bg-primary text-primary-foreground' : 'bg-card',
              )}
            >
              {selected ? <Check className="size-3" strokeWidth={3} /> : null}
            </span>
          </button>
        )
      })}
    </div>
  )
}
